import { PAGE_VIEW } from 'common-js/analytics/actionTypes';
import { sendAnalyticsEvent } from 'common-js/analytics/analytics';
import { HoloHelmet, PageLoadingErrorScreen } from 'common-js/components';
import useAppSelector from 'common-js/hooks/useAppSelector';
import useAppDispatch from 'common-js/hooks/useAppDispatch';
import { OrgModel } from 'common-js/models';
import { getOrganizations, getOrgGroups } from 'common-js/reducers/organization/actions';
import { getSelectedOrg } from 'common-js/reducers/organization/selectors';
import { useCallback, useEffect, useState, type FC } from 'react';
import { CollaboratorList, OrgIdPanel, OrgNamePanel } from './parts';

const SettingsOrg: FC = () => {
  const [pageError, setPageError] = useState<any>(null);

  const dispatch = useAppDispatch();
  const selectedOrg = useAppSelector(getSelectedOrg) || new OrgModel();

  const initialLoad = useCallback(async () => {
    try {
      await Promise.all([dispatch(getOrganizations()), dispatch(getOrgGroups())]);
    } catch (e) {
      setPageError(e);
    }
  }, [dispatch]);

  useEffect(() => {
    sendAnalyticsEvent({ type: PAGE_VIEW, data: { page: 'Settings - Org' } });

    initialLoad();
  }, [initialLoad]);

  return (
    <div className="settings-page SettingsOrg">
      <HoloHelmet title="Settings - Your Organization" />
      {pageError ? (
        <PageLoadingErrorScreen error={pageError} />
      ) : (
        <>
          <OrgNamePanel />
          <OrgIdPanel />
          {!selectedOrg.isMyAccount && <CollaboratorList />}
        </>
      )}
    </div>
  );
};

export default SettingsOrg;
